skrilla.controller('createBetBonusModal', function ($scope, searchService, modalService, validationService, cacheService, queryService) {
    $scope.entityDetails = cacheService.getObject("entityDetails")
    $scope.validate = {}
    $scope.request = {
        userClaimable:false,
        code:  $scope.entityDetails.slug,
        entityId:  $scope.entityDetails.id,
        entityType: $scope.entityDetails.type
    }
    $scope.promotionPurposes = {
            "WINNINGS_BOOST":true
    }

    $scope.select = function(definition){
        $scope.selectedDefinition = definition;
    }

    $scope.create = function(){
        searchService.get("promotions/codes/" + $scope.request.code + "/isAvailable").then(function (response) {
            if (response.data === true) {
                modalService.confirm("Are you sure you'd like to create this code?", function () {
                    const request = {
                        ...$scope.request,
                    };
                    searchService.post("promotions/definitions/" + $scope.selectedDefinition.id + "/codes", request).then(function (response) {
                        modalService.dismissAll();
                    })
                });
            }
            else {
                swal("Error!", "This code is not available", "error");
            }
        });
    }

});
